import React from 'react';

import { Icon, Text } from '../Primitives';

type Props = {
  overallStars: number;
  reviewsNumber: number;
  isShowTotal?: boolean;
  invert?: boolean;
};

const ReviewStar: React.FC<Props> = ({
  reviewsNumber,
  overallStars,
  isShowTotal,
  invert,
}) => {
  const renderStars = () => {
    const stars = [];
    for (let i = 1; i <= 5; i += 1) {
      if (i <= overallStars)
        stars.push(<Icon key={i} icon="star-full-colored" size="sm" />);
      else if (i - 0.5 <= overallStars)
        stars.push(<Icon key={i} icon="star-half-colored" size="sm" />);
      else stars.push(<Icon key={i} icon="star-empty-colored" size="sm" />);
    }
    return stars;
  };
  
  const textColorClass = invert ? 'text-white' : 'text-foreground';
  
  return reviewsNumber > 0 ? (
    <div className="flex items-center">
      {isShowTotal && (
        <Text variant="lb.md" className={`mr-1 ${textColorClass}`}>
          {overallStars}
        </Text>
      )}
      {renderStars()}
      <Text className={`ml-2 ${textColorClass}`}>
        {reviewsNumber} reviews
      </Text>
    </div>
  ) : (
    <Text className={textColorClass}>No reviews</Text>
  );
};

export default ReviewStar;
